import isAfter from 'date-fns/isAfter';
import { Map, List } from 'immutable';

export function taskDoctorHelper(
  tasks,
  elements,
  elementsRelationships,
  projectStartDate,
  relationshipsByType,
  dependencyTypeId,
  wbsRelTypeId,
  taskTypeId,
  relationships,
  orderedWbsElements,
) {
  if (!tasks.size) return {};

  const wbsElementLeafNodes = orderedWbsElements.reduce((p, c) => {
    if (c.get('children', []).length === 0) p.push(c);
    return p;
  }, []);
  
  const projectStartDateWithoutTimezone = projectStartDate && projectStartDate.slice(0, projectStartDate.indexOf('T'));

  const output = {
    finishDatePreceedStart: [],
    finishedBeforePred: [],
    startDatePreceedsProjectStart: [],
    finishDatePreceedsProjectStart: [],
    taskProgressWithoutStartDate: [],
    taskProgressWithoutResponsibileUser: [],
    taskHasNoRelationships: [],
    wbsElementsWithNoChildren: [],
  };

  const wbsRelationships = relationshipsByType.get(wbsRelTypeId, Map()).reduce((p, c) =>
    p.setIn([c.get('producer'), c.get('consumer')], true)
  , Map());

  if (wbsRelationships.size > 0) {
    wbsElementLeafNodes.forEach(leaf => {
      const leafId = leaf.get('id');
      if (wbsRelationships.get(leafId, Map()).size === 0) {
        output.wbsElementsWithNoChildren.push(leaf.set('name', leaf.get('title')));
      }
    });
  }

  const relationshipHashMap = relationshipsByType.get(dependencyTypeId, Map()).reduce((p, c) => {
    return p.set(c.get('consumer'), true).set(c.get('producer'), true)
  }, Map())

  tasks.forEach(t => {
    const status = t.getIn(['props', 'Status'], Map());
    const responsibleUser = t.getIn(['props', 'Responsibility'], '');

    if (responsibleUser === '' && status.get('status') !== 'Not Started') {
      output.taskProgressWithoutResponsibileUser = output.taskProgressWithoutResponsibileUser.concat(t);
    }

    if (status.get('status') !== 'Not Started') {
      const startDate = status.get('startDate');
      const startDateWithoutTimezone = startDate && startDate.slice(0, startDate.indexOf('T'));
      const finishDate = status.get('finishDate');
      const finishDateWithoutTimezone = finishDate && finishDate.slice(0, finishDate.indexOf('T'));

      if (startDateWithoutTimezone && isAfter(projectStartDateWithoutTimezone, startDateWithoutTimezone)) {
        output.startDatePreceedsProjectStart = output.startDatePreceedsProjectStart.concat(t);
      }

      if (!startDate) {
        output.taskProgressWithoutStartDate = output.taskProgressWithoutStartDate.concat(t);
      }

      if (finishDateWithoutTimezone && isAfter(projectStartDateWithoutTimezone, finishDateWithoutTimezone)) {
        output.finishDatePreceedsProjectStart = output.finishDatePreceedsProjectStart.concat(t);
      }

      if (startDate && finishDate && isAfter(startDateWithoutTimezone, finishDateWithoutTimezone)) {
        const updated = output.finishDatePreceedStart.concat(t);

        output.finishDatePreceedStart = updated;
      }

      const taskConsumers = elementsRelationships.getIn([t.get('id'), 'consumesFrom'], List());

      let startedBeforePred = false

      taskConsumers.forEach(rel => {
        const consumerId = relationships.getIn([rel, 'producer'], null);

        if (consumerId) {
          const element = elements.get(consumerId);
          const type = element && element.get('type');
 
          if (element && type === taskTypeId) {
            const hidden = relationships.getIn([rel, 'props', 'Assumption', 'hidden'], false);
            const status = elements.getIn([consumerId, 'props', 'Status', 'status'], '');

            if (status !== 'Finished' && !hidden) {
              startedBeforePred = true;
            }
          }
        }
      })

      if (startedBeforePred) output.finishedBeforePred = output.finishedBeforePred.concat(t);
    }

    if (!relationshipHashMap.get(t.get('id'))) {
      output.taskHasNoRelationships = output.taskHasNoRelationships.concat(t);
    }
  })

  return Object.keys(output).reduce((p, c) => {
    if (output[c].length) p[c] = output[c]
    return p;
  }, {})
}



// WEBPACK FOOTER //
// ./src/views/Project/TaskDoctor/helpers.js